import type {BrandPageContent} from '../../../brand/components/BrandPage/definition'

import type {homePage} from './content'
import {MOCK_COPY_DATA, type CopyData} from '../Index.data'

// eslint-disable-next-line unused-imports/no-unused-vars
export const parseContentfulData = (content: BrandPageContent<typeof homePage>): CopyData => {
  // TODO: Parse the finalized homepage definition into CopyData.
  return MOCK_COPY_DATA
}
